module.exports = __webpack_public_path__ + "static/media/background.17616c1b.png";